import PDFViewer from "./pages/PdfViewer";
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./pages/Home";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/sunnyvale" element={<PDFViewer location="Sunnyvale" />} />
        <Route path="/milpitas" element={<PDFViewer location="Milpitas" />} />
        <Route path="/fremont" element={<PDFViewer location="Fremont" />} />
        <Route path="/kaarthik" element={<PDFViewer location="Kaarthik" />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
